import * as React from "react";
import { DecorateEditorialHtml } from "src/components/flexComponents/Editorial/ContentUtilities";
import { UitkText } from "uitk-react-text";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { UitkSpacing } from "uitk-react-spacing";

const CONTENT_ID_COUNT = 3;
export const CardComparisonSectionEditorial = (props: { items: EditorialModel[]; cardComparisonClassName: string }) => {
  const { items, cardComparisonClassName } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [cardTitle, cardSubTitle, description] = React.useMemo(
    () => items.map((item) => <DecorateEditorialHtml key={item.id} text={item.text} />),
    []
  );

  return (
    <div className={cardComparisonClassName}>
      <UitkText align="center" size={700} weight="bold">
        <UitkSpacing padding={{ blockstart: "twelve" }}>
          <div>{cardTitle}</div>
        </UitkSpacing>
      </UitkText>
      <UitkText align="center" size={400} weight="bold">
        <UitkSpacing padding={{ blockstart: "one" }}>
          <div>{cardSubTitle}</div>
        </UitkSpacing>
      </UitkText>
      <UitkText align="center" size={200}>
        <UitkSpacing padding={{ blockstart: "two" }}>
          <div>{description}</div>
        </UitkSpacing>
      </UitkText>
    </div>
  );
};

export default CardComparisonSectionEditorial;
